import { render, staticRenderFns } from "./EducationExhibitionRegistration.vue?vue&type=template&id=63e9277c&scoped=true&"
import script from "./EducationExhibitionRegistration.vue?vue&type=script&lang=ts&"
export * from "./EducationExhibitionRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./EducationExhibitionRegistration.vue?vue&type=style&index=0&id=63e9277c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9277c",
  null
  
)

export default component.exports